export const reviewInsurancePageTranslations = {
  en: {
    reviewInsurancePage: {
      addAnotherInsurance: 'Add another insurance',
      confirmInsurance: 'Confirm insurance',
      removeInsuranceModalBody:
        'Your provider will need to review this change with you at your appointment. Would you like to continue with this removal?',
      removeInsuranceModalConfirm: 'Yes, flag for removal',
      removeInsuranceModalTitle: 'Remove this card?',
      title:
        'Review the insurance that we have on file, and let us know how you would like to continue.',
      withoutAddingInsurance:
        'Without adding insurance you may be fully responsible for your medical bill out-of-pocket.',
      invalidInsurancesModalTitle: 'Invalid card information',
      invalidInsurancesModalBody:
        'There is invalid or missing card information highlighted in red. Please edit or remove the highlighted card(s) before continuing.',
    },
  },
  es: {
    reviewInsurancePage: {
      addAnotherInsurance: 'Añadir otro seguro',
      confirmInsurance: 'Confirmar seguro',
      remove: 'Eliminar',
      removeInsuranceModalBody:
        'Su proveedor deberá revisar este cambio con usted en su cita. ¿Le gustaría continuar con esta eliminación?',
      removeInsuranceModalConfirm: 'Sí, marcar para eliminación',
      removeInsuranceModalTitle: 'Eliminar esta tarjeta?',
      title:
        'Revise el seguro que tenemos registrado y díganos cómo le gustaría continuar.',
      withoutAddingInsurance:
        'Sin agregar un seguro, usted puede ser totalmente responsable de pagar su factura médica de su bolsillo.',
    },
  },
};
